import { useTenantConfig } from '@packlink/tenant-config-provider';

import { routePathGenerator, RouterPaths } from '@utils/routes';

export const usePaths = (): RouterPaths => {
    const { routerPath: basePath } = useTenantConfig<ITenantConfig>();
    return routePathGenerator(basePath);
};
